import { useEffect, useState } from "react";
import styled from 'styled-components';

import {
  Container,
  FormControlLabel,
  Grid,
  Box,
  Radio,
  RadioGroup,
  Typography,
  Button,
  CircularProgress,
  Alert,
} from '@mui/material';

// * form
import { useForm } from 'react-hook-form';

// * services
import { postPaymentMethodByCustomer } from '../services/payments';

// components
import CardList from './CardList';
import BankForm from './BankForm';
import DigitalSignature from './DigitalSignature';
import SharedModal from './shared/SharedModal';
import RequiestStatusModal from './modals/RequiestStatusModal';
import { emailRegex, redirectPage, pagesUrl } from '../utils/misc';
import { useDeviceDetector } from '../hooks/useDeviceDetector';
import { useDeviceId } from '../hooks/useDeviceId';
import { IconCheckCircleOutlined } from "assets/icons/config";

const Main = styled(Container)`
  padding: 30px;
  .customerInfo {
    background: #f7f7f7;
    border-radius: 10px;
  }
`;

export default function PaymentMethodForm({
  customerId,
  agreementId,
  customerAgreements,
  bankList,
  setCustomerSignature,
  stampedCustomerSignature,
}) {
  const [option, setOption] = useState('card');

  // credit card
  const [cardName, setCardName] = useState('');
  const [cardNumber, setCardNumber] = useState('');
  const [cvc, setCvc] = useState('');
  const [expiry, setExpiry] = useState('');
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [currentStatus, setCurrentStatus] = useState('');
  const [emailError, setEmailError] = useState(null);
  const [error, setError] = useState(null);

  // *  bank form
  const [selectedAccount, setSelectedAccount] = useState(false);

  // *  card form
  const [selectedCard, setSelectedCard] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const { handleSubmit, control, reset, errors } = useForm();

  const currentBrand = localStorage.getItem('current_brand');

  const [brandId, setbrandId] = useState(currentBrand)

  const [disableSubmit, setDisableSubmit] = useState(true);

  const [showPaymentMethodValidationModal, setShowPaymentMethodValidationModal] = useState(false);
  const [formData, setFormData] = useState({});

  const [translatedCollection, setTranslatedCollection] = useState([]);

  const [errorCollection, setErrorCollection] = useState([]);

  const [cardErrors, setCardErrors] = useState([]);

  const { device } = useDeviceDetector();
  const { getDeviceId } = useDeviceId();

  const handleChange = (event) => {
    setOption(event.target.value);
  };

  useEffect(() => {
    if (errorCollection.length > 0) {
      const errors = [];
      errorCollection?.forEach((item) => {
        console.log('item.message', item.message);
        if (item.message) {
          errors.push({
            message: { message: item.message ?? "No se pudo validar el método de pago" },
          });
          return;
        }
        errors.push({
          message: item.message,
        });
      });
      setTranslatedCollection(errors);
    }
  }, [errorCollection]);

  useEffect(() => {
    if (
      (cardErrors.length > 0 ||
        cardNumber.length === 0 ||
        cvc.length === 0 ||
        expiry.length === 0) &&
      option == "card"
    ) {
      setDisableSubmit(true);
    } else {
      setDisableSubmit(false);
    }
  }, [cardErrors, option]);

  const pushError = (key, newError) => {
    if (!cardErrors.includes(key) && newError) {
      setCardErrors([...cardErrors, key]);
    } else {
      const filteredErrors = cardErrors.filter((err) => err !== key);
      setCardErrors(filteredErrors);
    }
  };

  const onFormSubmit = (data) => {

    if (option === 'card') {
      setShowPaymentMethodValidationModal(true); // Abrimos el modal
      setFormData(data); // Guardamos los datos para enviarlos tras confirmar
    } else {
      onSubmit(data)
    }
  };

  const handleConfirmCreditCard = () => {
    onSubmit(formData)
    setShowPaymentMethodValidationModal(false)
  }

  const onSubmit = async (data) => {
    let submitData = {
      customer_id: customerId,
      agreement_line_id: agreementId,
      signature_customer: stampedCustomerSignature,
    };

    // ! card payment
    if (option === 'card') {
      if (selectedCard) {
        submitData = {
          ...submitData,
          ...selectedCard,
          type: 'token_card',
        };
        submitData['card_number'] = selectedCard.account;
      } else {
        submitData = {
          ...submitData,
          type: 'token_card',
          name: data.name,
          number_document: data.number_document,
          type_document: data.type_document,
        };
        const expladeExpiryCard = expiry.split('/');
        submitData['name'] = cardName;
        submitData['expiration_month'] = expladeExpiryCard[0].replace(
          /\s/g,
          ''
        );
        submitData['security_code'] = cvc;
        submitData['expiration_year'] =
          '20' + expladeExpiryCard[1].replace(/\s/g, '');
        submitData['card_number'] = cardNumber;
      }

      // ! bank payment
    } else if (option === 'bank') {
      if (!emailRegex.test(data.email)) {
        setEmailError('Correo invalido');

        return;
      }

      if (selectedAccount) {
        submitData = {
          ...submitData,
          banks_id: selectedAccount.bank_id,
          account: selectedAccount.account,
          account_type: selectedAccount.account_type,
          type: 'bank_account',
        };
      } else {
        submitData = {
          ...submitData,
          banks_id: data.banks_id,
          account: data.account,
          account_type: data.account_type,
          type: 'bank_account',
          name: `${data?.name?.trim()} ${data?.first_last_name?.trim()} ${data?.second_last_name?.trim()}`.toUpperCase().trim(),
          last_name: `${data?.first_last_name?.trim()}`.toUpperCase(),
          number_document: data.number_document,
          type_document: data.type_document,
          mail: data.email,
        };
      }
    }

    submitData['log'] = device;
    submitData['device_id'] = getDeviceId();


    try {
      setCurrentStatus('')
      setErrorCollection([])
      setTranslatedCollection()
      setIsLoading(true);
      const response = await postPaymentMethodByCustomer(submitData);
      setShowStatusModal(true);
      setCurrentStatus(response?.data?.status);
      if (response && response?.data?.status === 'success') {
        setCurrentStatus(response?.data?.message);
        redirectPage(pagesUrl[brandId]);
      }
      if (response && response?.data?.status === 'error') {
        setCurrentStatus('NO SE PUDO TOKENIZAR EL MÉTODO DE PAGO');
        setErrorCollection(response?.data?.message);
      } else {
        setCurrentStatus('METODO DE PAGO ACTUALIZADO');
      }
    } catch (err) {
      setShowStatusModal(true);
      setCurrentStatus('NO SE PUDO TOKENIZAR EL MÉTODO DE PAGO');
      setErrorCollection(err?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const onError = () => { };

  return (
    <>
      <Main maxWidth="sm">
        <form onSubmit={handleSubmit(onFormSubmit, onError)}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box display={'flex'} justifyContent={'center'}>
                <Typography variant={'title'} color={'primary'} align="center">
                  {'Método de pago'}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box display={'flex'} justifyContent={'center'}>
                <Typography align="center">
                  Todas las transacciones se realizan de forma segura.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box display={'flex'} justifyContent={'center'}>
                <RadioGroup onChange={handleChange} value={option} row>
                  <FormControlLabel
                    value="card"
                    control={<Radio />}
                    label="CRÉDITO"
                  />
                  {brandId != 3 && (
                    <FormControlLabel
                      value="bank"
                      control={<Radio />}
                      label="CUENTA DE AHORROS/CORRIENTE"
                    />
                  )}
                </RadioGroup>
              </Box>
            </Grid>
            <Grid item xs={12}>
              {option === 'card' ? (
                <CardList
                  data={customerAgreements}
                  control={control}
                  cvc={cvc}
                  setCvc={setCvc}
                  expiry={expiry}
                  setExpiry={setExpiry}
                  cardNumber={cardNumber}
                  setCardNumber={setCardNumber}
                  setCardName={setCardName}
                  setSelectedCard={setSelectedCard}
                  selectedCard={selectedCard}
                  reset={reset}
                  pushError={pushError}
                  errors={errors}
                />
              ) : (
                <BankForm
                  data={customerAgreements}
                  control={control}
                  customerId={customerId}
                  bankList={bankList}
                  setSelectedAccount={setSelectedAccount}
                  selectedAccount={selectedAccount}
                  reset={reset}
                  errors={errors}
                  emailError={emailError}
                  setEmailError={setEmailError}
                />
              )}
            </Grid>
            <Grid item xs={12}>
              <Box display={'flex'} justifyContent={'center'}>
                <Typography align="center">
                  Estoy aceptando el debito mensual de este medio de pago
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box display={'flex'} justifyContent={'center'} mt={3}>
                <DigitalSignature setSignature={setCustomerSignature} />
              </Box>
            </Grid>
            {option === "card" && (
              <Grid item xs={12} style={{ marginTop: "10px" }}>
                <Alert severity="warning" style={{ fontSize: "0.8rem" }}>
                  Recuerda que no podrás inscribir una tarjeta débito o prepago, solo podrás inscribir una tarjeta crédito o una cuenta bancaria.
                </Alert>
              </Grid>
            )}

            <Grid item xs={12}>
              <Box display={'flex'} justifyContent={'center'} mt={3}>
                <Button
                  type="submit"
                  disabled={disableSubmit || isLoading}
                  variant="contained"
                  color="primary"
                >
                  {isLoading ? (
                    <CircularProgress size={30} color="primary" />
                  ) : (
                    <span>{"Guardar"}</span>
                  )}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
        {showStatusModal && (
          <SharedModal
            isOpen={showStatusModal}
            modalBody={
              <Box display={'flex'} justifyContent={'center'}>
                <RequiestStatusModal
                  handleClose={setShowStatusModal}
                  requestStatus={currentStatus}
                  errorCollection={translatedCollection}
                />
              </Box>
            }
          />
        )}

        {showPaymentMethodValidationModal && (
          <SharedModal
            isOpen={showPaymentMethodValidationModal}
            modalBody={
              <Box display={"flex-columns"} justifyContent={"center"} alignItems={'center'}>
                <Typography variant="h4" color={'primary'}>{'Validación Método de Pago'}</Typography>
                <br />
                <span>
                  Para verificar la validez de tu tarjeta y proteger tu seguridad, realizaremos un cargo temporal de <b>$1 USD.</b> Este monto será reembolsado automáticamente a tu tarjeta una vez completada la validación.
                </span>
                <br />
                <br />
                <Box display={'flex'} alignItems={'between'} justifyContent={'space-around'}>
                  <Button
                    onClick={() => setShowPaymentMethodValidationModal(false)}
                    variant="contained"
                    color="secondary">{'Cancelar'}</Button>
                  <Button
                    onClick={() => handleConfirmCreditCard()}
                    variant="contained"
                    color="primary"
                    endIcon={<IconCheckCircleOutlined
                      color="#fff" />
                    }>{'Aceptar'}</Button>
                </Box>
              </Box>
            }
          />
        )}
      </Main>
    </>
  );
}